import { useEffect, useState } from "react";
import UsersService from "../services/UsersService";
import Layout from "./include/layout";
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import PublicationsService from "../services/PublicationsService";
import AdminService from "../services/AdminService";
import { NumericFormat } from "react-number-format";
//import { authCheck } from "../services/http";
import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from "recharts";
import { useSelector } from "react-redux";

export default function Dashboard() {
	const navigate = useNavigate()

	const [totalUsers, setTotalUsers] = useState([])
	const [totalPublications, setTotalPublications] = useState([])
	const [totalAchats, setTotalAchat] = useState(0)
	const [totalCommandes, setTotalCommande] = useState(0)
	const [totalAbonnement, setTotalAbonnement] = useState()
	const [chiffre_affaire, setCA] = useState(0)
	const [commission_KD, setCommissionKd] = useState(0)
	const [ventes_publications, setVentesPublications] = useState(0)
	const [ratio_kd, setRatioKd] = useState(0)
	const [ratio_abonnements, setRatioAbonnement] = useState(0)
	const [ratio_achats, setRatioAchat] = useState(0)
	const auth = useSelector(state => state.auth)

	const [paiement_achat, setPaiementAchat] = useState([])
	const [paiement_abonnement, setPaiementAbonnement] = useState([])
	///############### METHODES #############################//
	///Graphe evolution des ventes et abonnements

	/*const graphex = [
		{
			name: 'Janvier',
			abn: 4000,
			achat: 2400,

		},
		{
			name: 'Fevrier',
			abn: 3000,
			achat: 1398,

		},
		{
			name: 'Mars',
			abn: 2000,
			achat: 9800,

		},
		{
			name: 'Avril',
			abn: 2780,
			achat: 3908,

		},
		{
			name: 'Mai',
			abn: 1890,
			achat: 4800,

		},
		{
			name: 'Juin',
			abn: 2390,
			achat: 3800,
			amt: 2400,

		},
	];*/

	////Script du graphe
	const graphe = paiement_achat.map((options, index) => ({
		name: new Date(options.dates).toLocaleString(['fr-FR'], { month: 'short' }),
		achat: options.montant_total || 0,
		abn: paiement_abonnement[index] ? paiement_abonnement[index].montant_total : 0,
		amt: 2400,
	  }));	  

	//console.log(graphe)

	useEffect(() => {

		const getTotalUsers = async () => {
			await UsersService.index(auth.token).then(response => {
				setTotalUsers(response.data.nombre_utilisateurs);
			}).catch(error => {
				console.log(error)
			})
		}
		//get liste publications
		const fetchPublications = async () => {
			await PublicationsService.index(auth.token).then((res) => {
				setTotalPublications(res.data.publications.length)
			}).catch(error => {
				console.log(error)
			})

		}

		const fetchTotal = async () => {
			await AdminService.dashboard(auth.token).then((res) => {
				//console.log(res.data.paiement_achat_six_dernier_mois)
				//######### DONNEES DU GRAPHE #################
				setPaiementAchat(res.data.paiement_achat_six_dernier_mois)
				setPaiementAbonnement(res.data.paiement_abonnement_six_dernier_mois)
				//######### END DONNEES DU GRAPHE #################

				setTotalCommande(res.data.achats_encours_count + res.data.abonnements_encours_count)
				setTotalAchat(res.data?.achats_count)
				setTotalAbonnement(res.data?.abonnements_encours_count)
				res.data.total_abonnements ? setCA(res.data.total_abonnements + res.data.total_achats) : setCA(0)
				setVentesPublications(res.data.total_achats)

				if (chiffre_affaire === 0) {
					// Calcul commissions KiosqueDigital
					setCommissionKd(0)
					// Ratio achats sur CA (en %) pour progress bar
					setRatioAchat(0)
					// Ratio abonnements sur CA (en %) pour progress bar
					setRatioAbonnement(0)
					// Ratio commissions dgbook sur CA (en %) pour progress bar
					//var ratio_kd = 0;
					setRatioKd(0)

				} else {
					// Calcul commissions dgbook
					setCommissionKd(chiffre_affaire / 3)
					// Ratio achats sur CA (en %) pour progress bar
					setRatioAchat(((res.data.total_achats * 100) / chiffre_affaire))
					// Ratio abonnements sur CA (en %) pour progress bar
					setRatioAbonnement(((res.data.total_abonnements * 100) / chiffre_affaire))
					// Ratio commissions dgbook sur CA (en %) pour progress bar
					//var ratio_kd = ((commission_KD * 100) / chiffre_affaire);
					setRatioKd(((commission_KD * 100) / chiffre_affaire))
				}

			}).catch(error => {
				console.log(error)
			})

		}

		getTotalUsers()
		fetchPublications()
		fetchTotal()
	}, [commission_KD, chiffre_affaire, navigate])

	///############### END METHODES #############################//

	return (
		<Layout>
			<div className="app-content pt-3 p-md-3 p-lg-4">
				<div className="container-xl">

					<h1 className="app-page-title mb-4">Dashboard</h1>

					{/*//Stats*/}
					<div className="row g-4 mb-4">
						<div className="col-6 col-lg-3">
							<div className="app-card app-card-stat shadow-sm h-100 bg-primary">
								<div className="app-card-body p-3 p-lg-4">
									<h4 className="stats-type mb-1" style={{ color: "#fff" }}>Publications</h4>
									<div className="stats-figure text-white">
										<i className="fas fa-file-word fa-lg" style={{ float: "left" }}></i>
										{totalPublications}</div>
								</div>{/*//app-card-body*/}
								<Link to={myroutes.publications_index} className="app-card-link-mask"></Link>
							</div>{/*//app-card*/}
						</div>{/*//col*/}

						<div className="col-6 col-lg-3">
							<div className="app-card app-card-stat shadow-sm h-100 bg-secondary">
								<div className="app-card-body p-3 p-lg-4">
									<h4 className="stats-type mb-1 text-white">Utilisateurs</h4>
									<div className="stats-figure text-white">
										<i className="fas fa-user fa-lg" style={{ float: "left" }}></i>{totalUsers}</div>
								</div>{/*//app-card-body*/}
								<Link className="app-card-link-mask" to={myroutes.users_index}></Link>
							</div>{/*//app-card*/}
						</div>{/*//col*/}
						<div className="col-6 col-lg-3">
							<div className="app-card app-card-stat shadow-sm h-100 bg-success">
								<div className="app-card-body p-3 p-lg-4">
									<h4 className="stats-type mb-1 text-white">Achats</h4>
									<div className="stats-figure text-white">
										<i className="fas fa-cart-arrow-down fa-lg" style={{ float: "left" }}></i>
										{totalAchats}</div>
								</div>{/*//app-card-body*/}
							</div>{/*//app-card*/}
						</div>{/*//col*/}
						<div className="col-6 col-lg-3">
							<div className="app-card app-card-stat shadow-sm h-100 bg-warning">
								<div className="app-card-body p-3 p-lg-4">
									<h4 className="stats-type mb-1 text-white">Commandes</h4>
									<div className="stats-figure text-white">
										<i className="fas fa-gifts fa-lg" style={{ float: "left" }}></i>{totalCommandes}</div>
									<div className="stats-meta text-white"></div>
								</div>{/*//app-card-body*/}
							</div>{/*//app-card*/}
						</div>{/*//col*/}
					</div>
					{/*//Stats*/}


					{/*//Graphe*/}
					<div className="row g-4 mb-4">
						<div className="col-12 col-lg-8">
							<div className="app-card app-card-chart h-100 shadow-sm">
								<div className="app-card-header p-3">
									<div className="row justify-content-between align-items-center">
										<div className="col-auto">
											<h4 className="app-card-title">Evolution des ventes et abonnements (F CFA)
											</h4>
										</div>{/*//col*/}
									</div>{/*//row*/}
								</div>{/*//app-card-header*/}
								<div className="app-card-body p-3 p-lg-4">
									<div className="chart-container table-responsive d-flex">
										<LineChart id="canvas-linechart" className="sticky-top"
											width={650}
											height={400}
											data={graphe}
											margin={{
												top: 5,
												right: 30,
												left: 20,
												bottom: 5,
											}}
										>
											<CartesianGrid strokeDasharray="3 3" />
											<XAxis dataKey="name" />
											<YAxis />
											<Tooltip />
											<Legend />
											<Line type="monotone" dataKey="achat" stroke="#8884d8" activeDot={{ r: 8 }} />
											<Line type="monotone" dataKey="abn" stroke="#82ca9d" />
										</LineChart>
									</div>
								</div>{/*//app-card-body*/}
							</div>{/*//app-card*/}
						</div>{/*//col*/}
						<div className="col-12 col-lg-4">
							<div className="app-card app-card-progress-list h-100 shadow-sm">
								<div className="app-card-header p-3">
									<div className="row justify-content-between align-items-center">
										<div className="col-auto">
											<h4 className="app-card-title">Etat des ventes</h4>
										</div>{/*//col*/}
										<div className="col-auto">
											<div className="card-header-action">
												<a href="#"></a>
											</div>{/*//card-header-actions*/}
										</div>{/*//col*/}
									</div>{/*//row*/}
								</div>{/*//app-card-header*/}
								<div className="app-card-body">
									<div className="item p-3">
										<div className="row align-items-center">
											<div className="col">
												<div className="title mb-1 ">Chiffres d'affaires </div>
												<strong style={{ fontSize: "22px", color: "#000" }}>
													<NumericFormat value={chiffre_affaire} displayType="text" thousandSeparator="." decimalSeparator="," suffix=" FCFA" />
												</strong>
												<div className="progress">
													<div className="progress-bar bg-success" role="progressbar"
														style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0"
														aria-valuemax="100"></div>
												</div>
											</div>{/*//col*/}
										</div>{/*//row*/}
									</div>{/*//item*/}


									<div className="item p-3">
										<div className="row align-items-center">
											<div className="col">
												<div className="title mb-1 ">Commissions KD</div>
												<strong style={{ fontSize: "22px", color: "#000" }}>
													<span style={{ fontSize: "18px", float: "right" }} className={ratio_kd >= 0 ? "text-success" : "text-danger"}><i style={{ fontSize: "12px" }} className="fas fa-arrow-right mx-2"></i>{ratio_kd}</span>
													<NumericFormat value={commission_KD} displayType="text" thousandSeparator="." decimalSeparator="," suffix=" FCFA" />
												</strong>
												<div className="progress">
													<div className="progress-bar bg-danger" role="progressbar"
														style={{ width: "34%" }} aria-valuenow="34" aria-valuemin="0"
														aria-valuemax="100"></div>
												</div>
											</div>{/*//col*/}
										</div>{/*//row*/}
									</div>{/*//item*/}

									<div className="item p-3">
										<div className="row align-items-center">
											<div className="col">
												<div className="title mb-1 ">Ventes de Publications</div>
												<strong style={{ fontSize: "22px", color: "#000" }}>
													<span style={{ fontSize: "18px", float: "right" }} className={ratio_achats >= 0 ? "text-success" : "text-danger"}><i style={{ fontSize: "12px" }} className="fas fa-arrow-right mx-2"></i>{ratio_achats}</span>
													<NumericFormat value={ventes_publications} displayType="text" thousandSeparator="." decimalSeparator="," suffix=" FCFA" />
												</strong>
												<div className="progress">
													<div className="progress-bar bg-info" role="progressbar"
														style={{ width: "68%" }} aria-valuenow="68" aria-valuemin="0"
														aria-valuemax="100"></div>
												</div>
											</div>{/*//col*/}
										</div>{/*//row*/}
									</div>{/*//item*/}

									<div className="item p-3">
										<div className="row align-items-center">
											<div className="col">
												<div className="title mb-1 ">Abonnements</div>
												<strong style={{ fontSize: "22px", color: "#000" }}>
													<span style={{ fontSize: "18px", float: "right" }} className={ratio_abonnements >= 0 ? "text-success" : "text-danger"}><i style={{ fontSize: "12px" }} className="fas fa-arrow-right mx-2"></i>{ratio_abonnements}</span>
													<NumericFormat value={totalAbonnement} displayType="text" thousandSeparator="." decimalSeparator="," suffix=" FCFA" />
												</strong>
												<div className="progress">
													<div className="progress-bar bg-warning" role="progressbar"
														style={{ width: "52%" }} aria-valuenow="52" aria-valuemin="0"
														aria-valuemax="100"></div>
												</div>
											</div>{/*//col*/}
										</div>{/*//row*/}
									</div>{/*//item*/}

								</div>{/*//app-card-body*/}
							</div>{/*//app-card*/}
						</div>{/*//col*/}

					</div>
					{/*//Graphe*/}

				</div>
				{/*//container-fluid*/}
			</div>
			{/*//app-content*/}
		</Layout>


	)


}

